import { Company } from "../company/company.types";

export enum Role {
    SuperAdmin = 'superadmin',
    Admin = 'admin',
    TeamLeader = 'team_leader',
    EquipmentDriver = 'equipment_driver',
    TruckDriver = 'truck_driver',
    Manager = 'manager',
    Mechanic = 'mechanic',
    WorkshopManager = 'workshop_manager',
    HumanResources = 'human_resources',
    Employee = 'employee',
}

export const RoleLabels: Record<Role, string> = {
    [Role.SuperAdmin]: 'Super Administrateur',
    [Role.Admin]: 'Administrateur',
    [Role.TeamLeader]: 'Chef d\'équipe',
    [Role.EquipmentDriver]: 'Conducteur d\'engin',
    [Role.TruckDriver]: 'Chauffeur PL',
    [Role.Manager]: 'Responsable et conducteur de travaux',
    [Role.Mechanic]: 'Mécanicien',
    [Role.WorkshopManager]: 'Responsable atelier',
    [Role.HumanResources]: 'Ressources humaines',
    [Role.Employee]: 'Salarié',
};

export interface Avatar {
    _id: string;
    url: string;
    name: string;
    mimetype: string;
}

export enum UserStatus {
    Online = 'online',
    Inactive = 'inactive',
    Offline = 'offline',
}

export interface User {
    _id?: string;
    // name: string;
    role: Role;
    email: string;
    phoneNumber?: string;
    firstName: string;
    lastName: string;
    password?: string;
    _company: Company;
    forcePasswordReset?: boolean;
    // objective: number;
    // isOrange: boolean;
    // isRed: boolean;
    // countryCode: string;
    // phone: string;
    // sendEmail: boolean;
    // sendSms: boolean;
    color: string;
    code: string;
    divaltoId: string;
    /** False keeps its saisies out of the Divalto export (default true). */
    syncToDivalto?: boolean;
    /** Code manquant ou rejeté par Divalto lors de la dernière synchronisation. */
    divaltoError?: boolean;
    /** Explication de l'erreur Divalto (une ligne par erreur). */
    divaltoErrorMessage?: string;

    // codeBis: string;
    // acceptCGU: boolean;
    // prepaie: Record<string, any>;
    // posteAtelier?: string;

    disabled?: boolean;
    _avatar?: Avatar;
    _teamMembers?: string[];
    temporary?: boolean;


    lastActivityAt?: string;
    termsAcceptedAt?: string;
    createdAt?: string;
    updatedAt?: string;

    // DISPLAY ONLY
    // soldeCP?: number | null;
}

export type Users = User[];


export interface FindUserQuery {
    _company?: string[];
    role?: Role[];
    search?: string;
    sort?: string;
    limit?: number;
    page?: number;
}

export class FindUserDto {
    query?: FindUserQuery;

    constructor(
        query?: FindUserQuery,
    ) {

        this.query = query;
        //  else {
        //     this.pagination = new FindEsgPaginationDto();
        // }
    }
}
